import { createSelector } from "@reduxjs/toolkit";

const selectCentrifugo = (s) => s.centrifugo;

export const centrifugoSelector = createSelector(
  [selectCentrifugo],
  (centrifugo) => centrifugo
);
